import { styled } from '@material-ui/core';

export const FormLabel = styled('label')(({ hasHelpText, theme }) => ({
  display: 'block',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.text.primary,
  padding: 0,
  fontWeight: '500',
  marginBottom: hasHelpText ? '2px' : '4px',
}));

export const FormError = styled('label')(({ theme }) => ({
  display: 'block',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.common.error,
  padding: 0,
  marginTop: '4px',
}));

export const FormHelpText = styled('span')(({ theme }) => ({
  display: 'block',
  fontSize: '12px',
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  padding: 0,
  marginBottom: '4px',
}));
